import { render, staticRenderFns } from "./NoLocal.vue?vue&type=template&id=2cb30059&scoped=true"
import script from "./NoLocal.vue?vue&type=script&lang=js"
export * from "./NoLocal.vue?vue&type=script&lang=js"
import style0 from "./NoLocal.vue?vue&type=style&index=0&id=2cb30059&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb30059",
  null
  
)

export default component.exports